<template>
  <div>
  </div>
</template>
<script>
import { Api } from "@/utils";
import $ from "jquery";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component()
export default class SearchArticles extends Vue {
  categories = [];
  skip = 0;
  fetchedArticles = [];
  lastScrollPosition = 0;

  @Watch("$route")
  watchRoute(to, from) {
    if (this.isOnSearchPage) {
      if (this.$route.name == "home") {
        this.$store.commit(
          "setCurrentKlass",
          this.$store.getters.classNameInUrl
        );
      }

      if (from.name != "article") {
        this.$store.commit("setSearchTerm", this.$route.query.s || "");
        this.$store.commit(
          "setSelectedCategories",
          (this.$route.query.c || "").split(",").filter(Boolean)
        );

        this.doThrottledSearch();
      } else if (!this.$store.state.article.articles.length) {
        this.doNewSearch();
        // this.$store.commit("forceNewSearch");
      }
    }
  }

  @Watch("$store.state.article.searchTerm")
  onSearchTermChange() {
    if (
      this.isOnSearchPageOrCreateArticle &&
      !this.$store.state.article.resetSearch
    ) {
      this.doThrottledSearch();
    }
  }

  @Watch("$store.state.article.selectedCategories")
  watchSelectedCategories() {
    if (this.isOnSearchPageOrCreateArticle) {
      this.doThrottledSearch();
    }
  }

  @Watch("$store.state.currentKlass")
  watchCurrentKlass() {
    if (this.isOnSearchPage && !this.$store.state.article.resetSearch) {
      this.doThrottledSearch();
    }
  }

  @Watch("$store.state.article.forcedNewSearch")
  watchForcedNewSearch(payload) {
    this.$store.commit("resetCurrentKlass");
    this.fetchedArticles = [];
    this.doNewSearch(payload.route);
  }

  @Watch('$store.state.article.fetchNewArticles')
  triggerFetchNewArticles() {
    if (!this.isOnSearchPageOrCreateArticle) return;
    this.fetchSearchedArticles()
  }

  get isFetching() {
    return this.$store.state.article.isFetching;
  }

  set isFetching(val) {
    this.$store.commit("setIsFetching", val);
  }

  doThrottledSearch() {
    if (!this.doSearchTimeout) {
      this.doSearchTimeout = setTimeout(() => {
        this.doSearchTimeout = undefined;
        this.doNewSearch();
      }, 10);
    }
  }

  doNewSearch(routeName = this.$route.name) {
    // this.skip = 0;
    this.$store.commit("resetSkip");
    this.isFirstSearchResult = true;
    this.$store.commit("setDidDisplayAllArticles", false);
    this.updateSearchUrl(routeName);
    this.fetchSearchedArticles();
  }

  get isOnSearchPage() {
    return ["home", "adminArticles"].includes(this.$route.name);
  }

  get isOnSearchPageOrCreateArticle() {
    return this.isOnSearchPage || this.$route.name == "createArticle";
  }

  get didDisplayAllArticles() {
    return this.$store.state.article.didDisplayAllArticles;
  }

  mounted() {
    if (this.isOnSearchPage) {
      this.doNewSearch();
    }

    // $(window).scroll(() => {
    //   this.onScroll();
    // });
  }

  beforeDestroy() {
    // $(window).unbind("scroll");
  }

  updateSearchUrl(routeName = this.$route.name) {
    let name = routeName;
    if (name == "createArticle") {
      return;
    }
    if (name != "adminArticles") {
      name = "home";
    }

    let s = this.$store.state.article.searchTerm || "";
    let c = this.$store.state.article.selectedCategories.join(",");
    if (c == this.$route.query.c && s == this.$route.query.s) {
      return;
    }

    let query = {};
    s && (query.s = s);
    c && (query.c = c);

    // Vue router dislikes pushing an identical route.
    if (
      this.$route.name != name ||
      JSON.stringify(query) !== JSON.stringify(this.$route.query)
    ) {
      this.$router.push({ name, query });
    }
  }

  onScroll() {
    // only listen to scroll on main page
    if (!this.isOnSearchPageOrCreateArticle) return;

    let windowPixelHeight = $(window).height();
    let scrollPosition = $(window).scrollTop() - this.lastScrollPosition;
    let scrollDiff = scrollPosition > windowPixelHeight * 0.5;

    if (
      scrollDiff &&
      !this.isFetching &&
      !this.didDisplayAllArticles &&
      !this.fetchedArticles.length
    ) {
      this.skip += 20;
      this.fetchSearchedArticles();
    }

    if (!this.stickyBottom) {
      this.stickyBottom = setInterval(() => {
        this.onBottom();
      }, 50);
    }
  }

  onBottom() {
    if (
      Math.round($(window).scrollTop() + $(window).height()) >
      $(document).height() - 50
    ) {
      if (!this.didDisplayAllArticles) {
        this.addFetchedArticles();
      }
    }
  }

  scrollToTop() {
    const pos = Math.min(window.scrollY, window.innerHeight * 0.4 - 49);
    window.scrollTo(0, pos);
  }

  async fetchSearchedArticles() {
    this.isFetching = true;
    this.$store.commit("setDidDisplayAllArticles", false);
    let query = [
      this.$store.state.article.searchTerm,
      this.$store.state.article.selectedCategories,
      this.$store.state.article.skip,
      // this.skip,
      this.$store.state.currentKlass,
    ];

    this.fetchedArticles = await SearchArticles.getSearchedArticles(...query);
    this.isFetching = false;
    this.$store.commit("setIsFetching", false);

    // if (this.skip == 0) {
    this.addFetchedArticles();
    // }
  }

  addFetchedArticles() {
    if (!this.isFetching) {
      if (this.isFirstSearchResult) {
        this.scrollToTop();
        this.$store.commit("setArticles", this.fetchedArticles);
      } else {
        this.$store.commit("appendArticles", this.fetchedArticles);
      }

      this.isFirstSearchResult = false;
      this.$store.commit(
        "setDidDisplayAllArticles",
        this.fetchedArticles.length < 1
      );
      this.fetchedArticles = [];
      clearInterval(this.stickyBottom);
      this.stickyBottom = undefined;
      this.lastScrollPosition = $(window).scrollTop();
    }
  }

  static async getSearchedArticles(
    searchTerm = "",
    categories = [],
    skip = 0,
    klass = "",
    admin = ""
  ) {
    klass = encodeURIComponent(klass);
    searchTerm = encodeURIComponent(searchTerm);
    let category = encodeURIComponent(categories.join(","));
    if (!searchTerm.length) {
      // if (!searchTerm.length && !categories.length) {
      return await Api.get(
        `articles?skip=${skip}&klass=${klass}&admin=${admin}&category=${category}`
      );
    } else {
      return await Api.get(
        `search-articles?term=${searchTerm}&skip=${skip}&category=${category}&klass=${klass}&admin=${admin}`
      );
    }
  }
}
</script>